import { Box } from '@mui/material';
import { useState } from 'react';
import useFetchApiData from '../../../core/hooks/useFetchApiData';
import Layout from '../../../core/ui/layout/Layout';
import TableContainer from '../../../core/ui/table/TableContainer';
import { TableHeader } from '../../../core/ui/table/tableTypes';
import { Paginated } from '../../../core/utils/types';
import { parseQuery } from '../../../core/utils/utility';
import { Contact } from '../contact';
import { useSendApiData } from '../../../core/hooks/useSendApiData';
import { toastError, toastMessage } from '../../../core/utils/ui/alert';

const tableHeaders: TableHeader[] = [
  { field: 'name', label: 'Name', align: 'left' },
  { field: 'email', label: 'Email', align: 'left' },
  { field: 'subject', label: 'Subject', align: 'left' },
  { field: 'message', label: 'Message', align: 'left' },
];
const ContactList = () => {
  const [data, setData] = useState<Record<string, any>[]>([]);
  const { fetchData } = useFetchApiData();
  const { callApi } = useSendApiData();

  const handleFetchData = async (query: any, cb: (c: number) => void) => {
    await fetchData(`auth-ea35a/contacts${parseQuery(query)}`, {
      onSuccess: ({ total, data: apiData }: Paginated<Contact>) => {
        setData(apiData);
        cb(total);
      },
    });
  };

  const handleDelete = async (id: number | string, showMessage = true) => {
    let success = false;

    await callApi({
      endpoint: `auth-ea35a/contacts/${id}`,
      data: {},
      method: 'delete',
      onSuccess: async () => {
        if (showMessage) toastMessage('Contact Removed');
        success = true;
      },
      onError: () => {
        if (showMessage)
          toastError('Something went wrong while deleting. Try again');
      },
    });

    return success;
  };

  return (
    <>
      <Layout>
        <Box sx={{ p: 2 }}>
          <TableContainer
            modelToken="contact"
            tableHeaders={tableHeaders}
            data={data}
            modelLabel="Contacts"
            addRoute="/contacts/create"
            editRoutePrefix="/contacts/edit"
            viewRoutePrefix="/contacts/view"
            actions={{
              onFetchData: handleFetchData,
              onDelete: handleDelete,
            }}
            fieldMap={{
              name: 'string',
              email: 'string',
              subject: 'string',
            }}
            settings={{
              canCreate: false,
              canEdit: false,
              canDelete: true,
              canViewItem: true,
            }}
          />
        </Box>
      </Layout>
    </>
  );
};

export default ContactList;
